// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview-result-table{border-bottom:1px solid #ddd;margin-bottom:0}.preview-result-table .test-name{font-size:15px}.preview-result-table tr.border-bottom-0,.preview-result-table tr.border-bottom-0 td{border-bottom:0}.preview-result-table tr.border-top-0,.preview-result-table tr.border-top-0 td{border-top:0}", ""]);
// Exports
module.exports = exports;
